import { useEffect, useState } from "react";
import { Button, Card, Col, Modal, Row, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";


export default function BillingInformations() {
    const items = [
        {
            id: 1,
            description: "Insight Plus - One year plan",
            date: "16/12/2024"
        },
        {
            id: 2,
            description: "Knowledge Pro",
            date: "26/12/2024"
        },
    ]
    const [receiptsData, setReceiptsData] = useState(items || []);
    const [modalShow, setModalShow] = useState(false);
    const navigate = useNavigate()


    return (
        <>
            <h2>Billing Informations</h2>
            <Card className="membership-card mb-3">
                <Card.Header className="bg-transparent border-bottom-0">
                    <h3 className="mb-0">Your Membership</h3>
                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col sm={6} lg={4} className="mb-4 mb-sm-0">
                            <p className="title">Membership Plan</p>
                            <h4>Insight Plus</h4>
                            <Button variant="outline-secondary" onClick={() => navigate('/pricing')}>Change / Upgrade Plan</Button>
                        </Col>
                        <Col sm={6} lg={4} className="mb-2 mb-sm-0">
                            <p className="title">Membership Fee</p>
                            <h4>$30 Monthly</h4>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} lg={4} className="mb-2 mb-sm-0">
                            <p className="title">Current Billing Period Start Date</p>
                            <h4>Dec 16, 2024</h4>
                        </Col>
                        <Col md={6} lg={4} className="mb-1 mb-sm-0">
                            <p className="title">Next Payment Due Date</p>
                            <h4>Dec 16, 2024</h4>
                            <Button variant="outline-secondary" onClick={() => navigate('/pricing')}>Renew Now</Button>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            <Card className="mb-4">
                <Card.Header className="d-flex align-items-center justify-content-between bg-transparent border-bottom-0">
                    <h3 className="mb-0">Receipts</h3>
                </Card.Header>
                <Card.Body>
                    <Table responsive className="receipt-table mb-0">
                        <thead>
                            <tr>
                                <th>Description</th>
                                <th>Date</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {receiptsData.length === 0 ? (
                                <tr>
                                    <td colSpan="3" className="text-center">No receipts available</td>
                                </tr>
                            ) : (
                                receiptsData.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.description}</td>
                                        <td>{item?.date}</td>
                                        <td className="text-end">
                                            <Button variant="outline-secondary">Download</Button>
                                            <Button variant="outline-secondary" className="ms-2">View Receipt</Button>
                                        </td>
                                    </tr>
                                )))}

                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
            <div className="text-end">
                <Button variant="link" className="px-0" onClick={() => setModalShow(true)}>Cancel Membership</Button>
            </div>
            <Modal
                //   {...props}
                show={modalShow}
                onHide={() => setModalShow(false)}
                centered
                className="cancel-modal"
            >
                <Modal.Header closeButton className="border-bottom-0 p-0">
                </Modal.Header>
                <Modal.Body className="p-0">
                    <Modal.Title>
                        Cancel Your Membership?
                    </Modal.Title>
                    <p className="sub-des">We’re sorry to see you go. You’ll still have access to premium features until the end of your billing cycle.</p>
                    <Row className="plan-row">
                        <Col sm={6} className="text-sm-end">
                            <p>Current Plan</p>
                            <h4 className="mb-0">Insight Plus</h4>
                        </Col>
                        <Col sm={6}>
                            <p>Next Renewal Date</p>
                            <h4 className="mb-0">October 20, 2025</h4>
                        </Col>
                    </Row>

                    <Card className="mb-1">
                        <Card.Body>
                            <h3>What Happens After Canceling:</h3>
                            <ul className="mb-0 list-unstyled">
                                <li><FaCheckCircle /> <span>You’ll keep premium access until renewal date</span></li>
                                <li><FaCheckCircle /> <span>After that, your account reverts to Free (Research Explorer)</span></li>
                                <li><FaCheckCircle /> <span>Saved articles remain in your dashboard</span></li>
                                <li><FaCheckCircle /> <span>Community access will be limited to browsing only</span></li>
                            </ul>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Body className="d-flex flex-wrap justify-content-between align-items-center py-1 pe-1 p-3">
                            <h3 className="mb-md-0">Switch to Yearly Plan and <span>Save 20%</span></h3>
                            <Button variant="outline-secondary">Switch Now</Button>
                        </Card.Body>
                    </Card>
                </Modal.Body>
                <Modal.Footer className="p-0 border-top-0">
                    <Button variant="outline-secondary" onClick={() => setModalShow(false)}>Keep My Membership</Button>
                    <Button variant="primary">Confirm Cancel</Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}